import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { NotificationProvider } from './components/NotificationContext';
import { ResourceProvider } from './resource/ResourceContext';
import { DashboardProvider } from './dashboard/DashboardProvider';
import posthog from 'posthog-js'; 
import { PostHogProvider } from '@posthog/react' 

posthog.init(process.env.REACT_APP_POSTHOG_TOKEN, { 
  api_host: process.env.REACT_APP_POSTHOG_HOST, 
  defaults: '2026-01-30', 
  opt_out_capturing_by_default: true,
}); 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}> 
      <ResourceProvider>
        <NotificationProvider>
          <DashboardProvider>
            <App />
          </DashboardProvider>  
        </NotificationProvider>
      </ResourceProvider>
    </PostHogProvider> 
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
